<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-12 17:38:16
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-27 17:17:31
-->
<template>
	<!-- 关联达人 -->
	<div class="drContactsCell" :key="row.id">
		<el-select
			v-model="anchorId"
			:loading-text="loading_danRen"
			clearable
			:popper-append-to-body="false"
			:loading="loading_Dren_icon"
			filterable
			@change="change"
			remote
			ref="template"
			:remote-method="remoteMethod_daRen"
			@visible-change="v => visibleChange(v, 'template')"
			@focus="focusFun_dRen"
			placeholder="请选择 / 搜索达人"
		>
			<el-option v-for="(item, index) in darenOptions" :key="index" :value="item.anchor_id" :label="item.anchor_name" class="footer-option">
				<div style="float: left" class="flex-row">
					<div class="footer-img ml-6 mr-6 mt-4">
						<img :src="item.head ? item.head : imgUrl" alt="" />
					</div>
					<div class="flex-column flex-just-start">
						<div>
							<span class="font-h4-regular">{{ item.anchor_name | textFormat(10) }}</span>
							<span class="fan">粉丝量：{{ item.fans_num }}</span>
						</div>
						<!-- 快速申样 选择达人后 再选择关联达人时展示这里， 视频号到不了这里-->
						<p class="douyin font-h4-regular">{{ platformId | formatPlatformName('unify') }}：{{ item.anchor_account }}</p>
					</div>
				</div>
			</el-option>
		</el-select>
		<add-talent-dialog ref="addTalentDialog" :platformId="platformId" @getDr="focusFun_dRen" />
		<add-ks-talent-dialog ref="addKsTalentDialog" :platformId="platformId" @getDr="focusFun_dRen" />
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';
import { getTeamSeaList } from '@/api/talentCRM';
import { getInstitutionAnchorList } from '@/api/secondColonelManage';
import addTalentDialog from '@/views/secondColonelManage/cooperativeColonel/components/addTalentDialog';
import addKsTalentDialog from '@/views/secondColonelManage/cooperativeColonel/components/addKsTalentDialog';
export default {
	name: 'drContactsCell',
	mixins: [mixin],
	watch: {
		'row.anchor_name': {
			handler(to) {
				this.anchorId = to;
			},
		},
	},
	data() {
		return {
			anchorId: '',
			loading_danRen: '加载中',
			loading_Dren_icon: false,
			form: {
				selectDare: '',
			},
			imgUrl: 'https://cdn.chaoyongbushou.com/wx/20211108/1636372139805-c010edeb4a822302594d57f1bb6687c.png',
			danRenObj: {},
			is_select_cont: true,
			darenOptions: [],
			pageInfo: {
				page_index: 1,
				page_size: 100,
			},
		};
	},
	components: {
		addTalentDialog,
		addKsTalentDialog,
	},
	computed: {
		teamInstitutionId() {
			return this.row.team_institution_id;
		},
		platformId() {
			return this.row.platformId;
		},
	},
	methods: {
		visibleChange(visible, refName) {
			if (visible) {
				const ref = this.$refs[refName];
				let popper = ref.$refs.popper;
				if (popper.$el) popper = popper.$el;
				if (!Array.from(popper.children).some(v => v.className === 'el-template-menu__list')) {
					const el = document.createElement('ul');
					el.className = 'el-template-menu__list';
					el.style = 'border-top:1px solid #EAEBF0; padding:0; color:rgb(64 158 255);font-size: 13px';
					el.innerHTML = `<li class="el-cascader-node text-center" style="height:37px;line-height: 50px">
                        <span class="yx-color-primary"><i class="font-blue el-icon-plus"></i>新增关联达人</span>
                        </li>`;
					popper.appendChild(el);
					el.onclick = () => {
						this.showTalentDraw();
					};
				}
			}
		},
		//远程搜索
		async remoteMethod_daRen(e) {
			this.loading_Dren_icon = true;
			this.loading_danRen = '加载中';
			const { teamInstitutionId, pageInfo, platformId: platform_id } = this;
			const { code, data } = await getInstitutionAnchorList({ ...pageInfo, team_institution_id: teamInstitutionId, anchor_name: e, platform_id });
			this.loading_Dren_icon = false;
			if (code == 0) {
				this.darenOptions = data.list.filter(item => item.anchor_id != 0);
			}
		},
		async focusFun_dRen(account, value) {
			this.loading_Dren_icon = true;
			this.loading_danRen = '加载中';
			const { teamInstitutionId, pageInfo, platformId: platform_id } = this;
			const { code, data } = await getInstitutionAnchorList({
				...pageInfo,
				team_institution_id: teamInstitutionId,
				anchor_name: '',
				platform_id,
			});
			if (code == 0) {
				this.darenOptions = data.list.filter(item => item.anchor_id != 0);
				if (value) {
					let obj = this.darenOptions.find(v => v.anchor_account == account) || {};
					this.row.anchor_id = obj?.anchor_id;
					this.row.anchor_name = obj?.anchor_name;
				}
				this.darenOptions.length ? (this.loading_Dren_icon = false) : (this.loading_danRen = '无数据');
			}
		},
		// 新增关联达人
		showTalentDraw() {
			const ref = {
				[dataMap.PLATFORM_DY.value]: this.$refs.addTalentDialog.show,
				[dataMap.PLATFORM_KS.value]: this.$refs.addKsTalentDialog.show,
			};
			ref[this.platformId](this.teamInstitutionId);
		},
		change(e) {
			this.row.anchor_id = e;
			this.row.anchor_name = this.darenOptions?.find(v => v.anchor_id === e)?.anchor_name || '';
		},
	},
};
</script>
<style lang="less" scoped>
.footer-img {
	img {
		width: 36px;
		height: 36px;
		border-radius: 50%;
	}
}
.douyin {
	margin-top: 2px;
	color: #86909d;
	font-size: 12px;
}
.fan {
	flex: 1;
	white-space: nowrap;
	height: 20px;
	color: #fdd2a1;
	font-size: 12px;
	padding: 1px 2px;
	margin-left: 5px;
	border: 1px solid #fdd2a1;
}
/deep/.el-select-dropdown__item {
	height: 59px !important;
	line-height: 26px;
}
/deep/ .el-input__inner {
	font-size: 12px !important;
}
</style>
